var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconBold = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.48535 12.9385H6.06445C8.75391 12.9385 10.4502 11.5234 10.4502 9.35254C10.4502 7.63867 9.21094 6.39941 7.42676 6.30273V6.23242C8.88574 6.03027 9.87891 4.93164 9.87891 3.53418C9.87891 1.57422 8.37598 0.370117 5.94141 0.370117H1.48535C0.544922 0.370117 0 0.923828 0 1.89062V11.4268C0 12.3848 0.544922 12.9385 1.48535 12.9385ZM2.90039 5.59082V2.43555H5.0625C6.29297 2.43555 7.02246 2.99805 7.02246 3.96484C7.02246 4.98438 6.21387 5.59082 4.84277 5.59082H2.90039ZM2.90039 10.9082V7.41895H5.10645C6.64453 7.41895 7.50586 8.0166 7.50586 9.1416C7.50586 10.293 6.67969 10.9082 5.16797 10.9082H2.90039Z",
    fill: "#FCFCFC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconBold);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-bold.bc0b7316d4c4f7cebd85e2e5ed434058.svg";